import { render, staticRenderFns } from "./RouteWrapper.vue?vue&type=template&id=9cbeba8a&"
import script from "./RouteWrapper.vue?vue&type=script&lang=js&"
export * from "./RouteWrapper.vue?vue&type=script&lang=js&"
import style0 from "./RouteWrapper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports